const DEFAULTS = {
  global: {
    channelTracking: true,
    collections2: true,
    flexPromo: false,
    kibana: {
      enabled: false,
    },
    peacockPromo: false,
    xapExitEnabled: true,
    xapInterstitial: true,
    xapSoftDisco: false,
  },
  'bill-pay': {
    accountNameApiEnabled: true,
    applePayApiUpgradeEnabled: true,
    applePayEnabled: true, // enable applePay
    arrangementFlowEnabled: true, // enables payment arrangement
    cmsPromoModule: true,
    // crsId/consentId flow
    consent: {
      // Whether to enable consent flow at all
      enabled: true,
      // Whether ecobill is presented as an option for consent flow
      // TODO: remove; this is stable now
      ecobill: true,
      // Whether to fetch accepted contracts when in consent flow
      acceptedContracts: false,
    },
    coreUnifiedWalletPhase1Enabled: true,
    coreUnifiedWalletPhase2Enabled: true,
    cpcVersion: '3.1.2',
    deferredPaymentEnabled: true,
    enableGlobalNav: true,
    forceGlobalNav: true,
    installmentFlowEnabled: true,
    kibana: {
      enabled: false,
    },
    // Payment setup page
    paymentSetup: {
      enabled: true,
    },
    p2pMessaging: true,
    prefetchCoreNowCPCEnabled: true,
    replaceAccountApiPhase1Enabled: true,
    replaceAccountNameApiEnabled: true,
    replaceBillCurrentApiPhase1Enabled: true,
    replaceBillCurrentApiPhase2Enabled: true,
    replaceDelinquencyApiEnabled: true,
    replaceDelinquencyApiPhase2Enabled: true,
    replaceIndicatorsApiEnabled: true,
    replaceIndicatorsApiPhase2Enabled: true,
    replaceMacaroonApiEnabled: false,
    replaceSsmStepUpEnabled: false,
    serviceRecoveryEnabled: true,
    splitPaymentEnabled: true,
    txnDataTokenizationEnabled: true,
    txnDataPaymentEnabled: true,
    xapExitPlanEnabled: true, // if false, redirect to payflow/suppress CTA
    xmACHEnabled: true,
    xmDeviceReskinEnabled: true,
    xmPaymentArrangementEnabled: true,
    xmPaymentReskinEnabled: true,
    xmTxnDataEnabled: true,
  },
};

export default DEFAULTS;
